import { render } from "./ContactDetails.vue?vue&type=template&id=64bdbe9c&scoped=true"
import script from "./ContactDetails.vue?vue&type=script&lang=js"
export * from "./ContactDetails.vue?vue&type=script&lang=js"

import "./ContactDetails.vue?vue&type=style&index=0&id=64bdbe9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bdbe9c"]])

export default __exports__